module.exports = __webpack_public_path__ + "static/media/prenda2-min.ce5a9e59.jpg";